import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/Login.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Home from "../views/Home.vue";
// import Test from "../views/Test.vue";
import Dashboard from "../views/Dashboard.vue";
import DashboardPasien from "../views/Dashboard/Pasien.vue";
import DashboardPenyakit from "../views/Dashboard/Penyakit.vue";
import DashboardObat from "../views/Dashboard/Obat.vue";
import DashboardOptik from "../views/Dashboard/Optik.vue";
import DashboardTindakan from "../views/Dashboard/Tindakan.vue";
import DashboardLab from "../views/Dashboard/Lab.vue";

import DashboardMenular from "../views/Dashboard/Menular.vue";
import DashboardRujukan from "../views/Dashboard/Rujukan.vue";
import DashboardBor from "../views/Dashboard/Bor.vue";
import DashboardAlos from "../views/Dashboard/Alos.vue";
import DashboardBto from "../views/Dashboard/Bto.vue";
import DashboardToi from "../views/Dashboard/Toi.vue";
import DashboardNdr from "../views/Dashboard/Ndr.vue";
import DashboardGdr from "../views/Dashboard/Gdr.vue";
import DashboardBj from "../views/Dashboard/Bj.vue";
import DashboardRl from "../views/Dashboard/Rl.vue";
import DashboardRl2 from "../views/Dashboard/Rl2.vue";
import DashboardRl3 from "../views/Dashboard/Rl3.vue";
import DashboardRl4 from "../views/Dashboard/Rl4.vue";
import DashboardRl5 from "../views/Dashboard/Rl5.vue";
import DashboardRo from "../views/Dashboard/Ro.vue";

import Antrian from "../views/Antrian/Index.vue";
import AntrianPasien from "../views/Antrian/Pasien.vue";
import AntrianSelesai from "../views/Antrian/Selesai.vue";
import Apotik from "../views/Apotik/Index.vue";
import Kasir from "../views/Kasir/Index.vue";
import Lab from "../views/Lab/Index.vue";
import Operasi from "../views/Operasi/Index.vue";
import Optik from "../views/Optik/Index.vue";
import Pasien from "../views/Pasien/Index.vue";
import PasienMutasi from "../views/Pasien/Mutasi.vue";
import PasienRetensi from "../views/Pasien/Retensi.vue";
import Ralan from "../views/Ralan/Index.vue";
import Ranap from "../views/Ranap/Index.vue";
import Ugd from "../views/Ugd/Index.vue";

import ApotikDetail from "../views/Apotik/Detail.vue";
import KasirDetail from "../views/Kasir/Detail.vue";
import LabDetail from "../views/Lab/Detail.vue";
import OperasiDetail from "../views/Operasi/Detail.vue";
import OptikDetail from "../views/Optik/Detail.vue";
import PasienDetail from "../views/Pasien/Detail.vue";
import PasienCetakKartu from "../views/Pasien/CetakKartu.vue";
import PasienCetakRiwayatKontrol from "../views/Pasien/CetakRiwayatKontrol.vue";
import RalanDetail from "../views/Ralan/Detail.vue";
import RalanCetakKartu from "../views/Ralan/CetakKartu.vue";
import RalanCetakKajianMedis from "../views/Ralan/CetakKajianMedis.vue";
import RalanCetakResepObat from "../views/Ralan/CetakResepObat.vue";
import RalanCetakResepOptik from "../views/Ralan/CetakResepOptik.vue";
import RanapDetail from "../views/Ranap/Detail.vue";
import UgdDetail from "../views/Ugd/Detail.vue";

import ApotikForm from "../views/Apotik/Form.vue";
import KasirForm from "../views/Kasir/Form.vue";
import KasirFormRalan from "../views/Kasir/FormRalan.vue";
import KasirFormRanap from "../views/Kasir/FormRanap.vue";
import KasirFormUgd from "../views/Kasir/FormUgd.vue";
import KasirFormObat from "../views/Kasir/FormObat.vue";
import KasirFormOptik from "../views/Kasir/FormOptik.vue";
import KasirFormLab from "../views/Kasir/FormLab.vue";
import KasirFormOperasi from "../views/Kasir/FormOperasi.vue";
import KasirInvoice from "../views/Kasir/Invoice.vue";
import KasirInvoiceRanap from "../views/Kasir/InvoiceRanap.vue";
import KasirInvoiceUgd from "../views/Kasir/InvoiceUgd.vue";
import KasirInvoiceObat from "../views/Kasir/InvoiceObat.vue";
import KasirInvoiceOptik from "../views/Kasir/InvoiceOptik.vue";
import KasirInvoiceLab from "../views/Kasir/InvoiceLab.vue";
import KasirInvoiceOperasi from "../views/Kasir/InvoiceOperasi.vue";
import LabForm from "../views/Lab/Form.vue";
import OperasiForm from "../views/Operasi/Form.vue";
import OperasiFormEdit from "../views/Operasi/FormEdit.vue";
import OptikForm from "../views/Optik/Form.vue";
import PasienForm from "../views/Pasien/Form.vue";
import PasienFormEdit from "../views/Pasien/FormEdit.vue";
import RalanDaftar from "../views/Ralan/Daftar.vue";
import RalanForm from "../views/Ralan/Form.vue";
import RalanFormEdit from "../views/Ralan/FormEdit.vue";
import RalanFormOptik from "../views/Ralan/FormOptik.vue";
import RalanFormTindakan from "../views/Ralan/FormTindakan.vue";
import RalanFormObat from "../views/Ralan/FormObat.vue";
import RalanFormDokter from "../views/Ralan/FormDokter.vue";
import RalanFormPetugas from "../views/Ralan/FormPetugas.vue";
import RalanFormOphthalmic from "../views/Ralan/FormOphthalmic.vue";
import RalanFormDokterEdit from "../views/Ralan/FormDokterEdit.vue";
import RalanFormPetugasEdit from "../views/Ralan/FormPetugasEdit.vue";
import RalanFormOphthalmicEdit from "../views/Ralan/FormOphthalmicEdit.vue";

import RanapForm from "../views/Ranap/Form.vue";
import RanapFormEdit from "../views/Ranap/FormEdit.vue";
import RanapFormTindakan from "../views/Ranap/FormTindakan.vue";
import RanapFormObat from "../views/Ranap/FormObat.vue";
import RanapFormLab from "../views/Ranap/FormLab.vue";
import RanapFormTindakanEdit from "../views/Ranap/FormTindakanEdit.vue";

// import RanapFormTagihan from "../views/Ranap/FormTagihan.vue";
import RanapFormDokter from "../views/Ranap/FormDokter.vue";
import RanapFormPetugas from "../views/Ranap/FormPetugas.vue";
import RanapFormDokterEdit from "../views/Ranap/FormDokterEdit.vue";
import RanapFormPetugasEdit from "../views/Ranap/FormPetugasEdit.vue";
import RanapFormTagihan from "../views/Ranap/FormTagihan.vue";
import RanapFormTagihanEdit from "../views/Ranap/FormTagihanEdit.vue";

import UgdFormTriase from "../views/Ugd/FormTriase.vue";
import UgdFormTriaseEdit from "../views/Ugd/FormTriaseEdit.vue";
import UgdDaftar from "../views/Ugd/Daftar.vue";
import UgdForm from "../views/Ugd/Form.vue";
import UgdFormEdit from "../views/Ugd/FormEdit.vue";
import UgdFormOptik from "../views/Ugd/FormOptik.vue";
import UgdFormTindakan from "../views/Ugd/FormTindakan.vue";
import UgdFormObat from "../views/Ugd/FormObat.vue";
import UgdFormDokter from "../views/Ugd/FormDokter.vue";
import UgdFormPetugas from "../views/Ugd/FormPetugas.vue";
import UgdFormOphthalmic from "../views/Ugd/FormOphthalmic.vue";
import UgdFormDokterEdit from "../views/Ugd/FormDokterEdit.vue";
import UgdFormPetugasEdit from "../views/Ugd/FormPetugasEdit.vue";
import UgdFormOphthalmicEdit from "../views/Ugd/FormOphthalmicEdit.vue";

import RanapKamar from "../views/Ranap/Kamar.vue";

import OperasiFormBiaya from "../views/Operasi/FormBiaya.vue";
import OperasiFormCeklis from "../views/Operasi/FormCeklis.vue";
import OperasiFormKondisi from "../views/Operasi/FormKondisi.vue";
import OperasiFormLaporan from "../views/Operasi/FormLaporan.vue";
import OperasiFormObat from "../views/Operasi/FormObat.vue";
import OperasiFormSurveilans from "../views/Operasi/FormSurveilans.vue";
import OperasiFormTindakan from "../views/Operasi/FormTindakan.vue";

import ApotikTebus from "../views/Apotik/Tebus.vue";
import OptikTebus from "../views/Optik/Tebus.vue";
import LabPeriksa from "../views/Lab/Periksa.vue";
import RanapDaftar from "../views/Ranap/Daftar.vue";
import OperasiDaftar from "../views/Operasi/Daftar.vue";

import KasirRalan from "../views/Kasir/Ralan.vue";
import KasirRanap from "../views/Kasir/Ranap.vue";
import KasirUgd from "../views/Kasir/Ugd.vue";
import KasirObat from "../views/Kasir/Obat.vue";
import KasirOptik from "../views/Kasir/Optik.vue";
import KasirLab from "../views/Kasir/Lab.vue";
import KasirOperasi from "../views/Kasir/Operasi.vue";

import Asuransi from "../views/Master/Asuransi/Index.vue";
import AsuransiForm from "../views/Master/Asuransi/Form.vue";
import AsuransiEdit from "../views/Master/Asuransi/Edit.vue";

import AsuransiLain from "../views/Master/AsuransiLain/Index.vue";
import AsuransiLainForm from "../views/Master/AsuransiLain/Form.vue";
import AsuransiLainEdit from "../views/Master/AsuransiLain/Edit.vue";

import Bank from "../views/Master/Bank/Index.vue";
import BankForm from "../views/Master/Bank/Form.vue";
import BankEdit from "../views/Master/Bank/Edit.vue";

import Kamar from "../views/Master/Kamar/Index.vue";
import KamarForm from "../views/Master/Kamar/Form.vue";
import KamarEdit from "../views/Master/Kamar/Edit.vue";

import Penyakit from "../views/Master/Penyakit/Index.vue";
import PenyakitForm from "../views/Master/Penyakit/Form.vue";
import PenyakitEdit from "../views/Master/Penyakit/Edit.vue";

import Dokter from "../views/Master/Dokter/Index.vue";
import DokterForm from "../views/Master/Dokter/Form.vue";
import DokterEdit from "../views/Master/Dokter/Edit.vue";
import DokterDetail from "../views/Master/Dokter/Detail.vue";
import DokterJadwal from "../views/Master/Dokter/Jadwal.vue";

import JadwalDokter from "../views/Master/JadwalDokter/Index.vue";
import JadwalDokterForm from "../views/Master/JadwalDokter/Form.vue";
import JadwalDokterEdit from "../views/Master/JadwalDokter/Edit.vue";

import Periode from "../views/Master/Periode/Index.vue";
import PeriodeForm from "../views/Master/Periode/Form.vue";
import PeriodeEdit from "../views/Master/Periode/Edit.vue";

import Kecamatan from "../views/Master/Kecamatan/Index.vue";
import KecamatanForm from "../views/Master/Kecamatan/Form.vue";
import KecamatanEdit from "../views/Master/Kecamatan/Edit.vue";

import Kelurahan from "../views/Master/Kelurahan/Index.vue";
import KelurahanForm from "../views/Master/Kelurahan/Form.vue";
import KelurahanEdit from "../views/Master/Kelurahan/Edit.vue";

import Kota from "../views/Master/Kota/Index.vue";
import KotaForm from "../views/Master/Kota/Form.vue";
import KotaEdit from "../views/Master/Kota/Edit.vue";

import Obat from "../views/Master/Obat/Index.vue";
import ObatForm from "../views/Master/Obat/Form.vue";
import ObatEdit from "../views/Master/Obat/Edit.vue";

import OptikItem from "../views/Master/OptikItem/Index.vue";
import OptikItemForm from "../views/Master/OptikItem/Form.vue";
import OptikItemEdit from "../views/Master/OptikItem/Edit.vue";

import PeriksaLab from "../views/Master/PeriksaLab/Index.vue";
import PeriksaLabForm from "../views/Master/PeriksaLab/Form.vue";
import PeriksaLabEdit from "../views/Master/PeriksaLab/Edit.vue";

import Petugas from "../views/Master/Petugas/Index.vue";
import PetugasForm from "../views/Master/Petugas/Form.vue";
import PetugasEdit from "../views/Master/Petugas/Edit.vue";

import Provinsi from "../views/Master/Provinsi/Index.vue";
import ProvinsiForm from "../views/Master/Provinsi/Form.vue";
import ProvinsiEdit from "../views/Master/Provinsi/Edit.vue";

import WilayahKota from "../views/Master/Provinsi/Kota.vue";
import WilayahKecamatan from "../views/Master/Provinsi/Kecamatan.vue";
import WilayahKelurahan from "../views/Master/Provinsi/Kelurahan.vue";

import Tindakan from "../views/Master/Tindakan/Index.vue";
import TindakanForm from "../views/Master/Tindakan/Form.vue";
import TindakanEdit from "../views/Master/Tindakan/Edit.vue";

import Unit from "../views/Master/Unit/Index.vue";
import UnitForm from "../views/Master/Unit/Form.vue";
import UnitEdit from "../views/Master/Unit/Edit.vue";

import User from "../views/Master/User/Index.vue";
import UserForm from "../views/Master/User/Form.vue";
import UserEdit from "../views/Master/User/Edit.vue";
import UserChangePassword from "../views/Master/User/ChangePassword.vue";

import DocumentExample from "../views/Document/Example.vue";
import DocKajianMedis from "../views/Document/KajianMedis.vue";
import DocKartuPasien from "../views/Document/KartuPasien.vue";
import DocOphthalmic from "../views/Document/Ophthalmic.vue";
import DocPenandaanLokasiOperasi from "../views/Document/PenandaanLokasiOperasi.vue";
import DocPenolakan from "../views/Document/Penolakan.vue";
import DocPeriksaPasien from "../views/Document/PeriksaPasien.vue";
import DocPersetujuan from "../views/Document/Persetujuan.vue";
import DocLaporanOperasi from "../views/Document/LaporanOperasi.vue";
import DocResepObat from "../views/Document/ResepObat.vue";
import DocResepOptik from "../views/Document/ResepOptik.vue";
import DocRiwayatKontrol from "../views/Document/RiwayatKontrol.vue";
import DocStikerObat from "../views/Document/StikerObat.vue";
import DocSuratKetMedis from "../views/Document/SuratKetMedis.vue";
import DocSuratKetSakit from "../views/Document/SuratKetSakit.vue";
import DocSuratKontrol from "../views/Document/SuratKontrol.vue";
import DocSuratPeriksaMata from "../views/Document/SuratPeriksaMata.vue";
import DocSuratPermintaanKonsultasi from "../views/Document/SuratPermintaanKonsultasi.vue";
import DocSuratRujukan from "../views/Document/SuratRujukan.vue";
import DocSuratRujukBalik from "../views/Document/SuratRujukBalik.vue";

import Komisi from "../views/Komisi/Index.vue";
import KomisiDetail from "../views/Komisi/Detail.vue";
import KomisiDaftar from "../views/Komisi/Daftar.vue";
import KomisiForm from "../views/Komisi/Form.vue";

import Faskes from "../views/Master/Faskes/Index.vue";
import FaskesForm from "../views/Master/Faskes/Form.vue";
import FaskesEdit from "../views/Master/Faskes/Edit.vue";

import Lokasi from "../views/Master/Lokasi/Index.vue";
import LokasiForm from "../views/Master/Lokasi/Form.vue";
import LokasiEdit from "../views/Master/Lokasi/Edit.vue";

import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/master/asuransi",
    name: "Asuransi",
    component: Asuransi,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/asuransi/form",
    name: "AsuransiForm",
    component: AsuransiForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/asuransi/edit",
    name: "AsuransiEdit",
    component: AsuransiEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kamar",
    name: "Kamar",
    component: Kamar,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kamar/form",
    name: "KamarForm",
    component: KamarForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kamar/edit/:id",
    name: "KamarEdit",
    component: KamarEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/penyakit",
    name: "Penyakit",
    component: Penyakit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/penyakit/form",
    name: "PenyakitForm",
    component: PenyakitForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/penyakit/edit/:id",
    name: "PenyakitEdit",
    component: PenyakitEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/dokter",
    name: "Dokter",
    component: Dokter,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/dokter/form",
    name: "DokterForm",
    component: DokterForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/dokter/edit/:id",
    name: "DokterEdit",
    component: DokterEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/dokter/detail/:id",
    name: "DokterDetail",
    component: DokterDetail,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/dokter/jadwal/:id",
    name: "DokterJadwal",
    component: DokterJadwal,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/jadwal-dokter",
    name: "JadwalDokter",
    component: JadwalDokter,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/jadwal-dokter/form",
    name: "JadwalDokterForm",
    component: JadwalDokterForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/jadwal-dokter/edit/:id",
    name: "JadwalDokterEdit",
    component: JadwalDokterEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/optik-item",
    name: "OptikItem",
    component: OptikItem,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/optik-item/form",
    name: "OptikItemForm",
    component: OptikItemForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/optik-item/edit/:id",
    name: "OptikItemEdit",
    component: OptikItemEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kecamatan",
    name: "Kecamatan",
    component: Kecamatan,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kecamatan/form",
    name: "KecamatanForm",
    component: KecamatanForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kecamatan/edit/:id",
    name: "KecamatanEdit",
    component: KecamatanEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kelurahan",
    name: "Kelurahan",
    component: Kelurahan,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kelurahan/form",
    name: "KelurahanForm",
    component: KelurahanForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kelurahan/edit/:id",
    name: "KelurahanEdit",
    component: KelurahanEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/periode",
    name: "Periode",
    component: Periode,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/periode/form",
    name: "PeriodeForm",
    component: PeriodeForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/periode/edit/:id",
    name: "PeriodeEdit",
    component: PeriodeEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kota",
    name: "Kota",
    component: Kota,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kota/form",
    name: "KotaForm",
    component: KotaForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/kota/edit/:id",
    name: "KotaEdit",
    component: KotaEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/obat",
    name: "Obat",
    component: Obat,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/obat/form",
    name: "ObatForm",
    component: ObatForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/obat/edit/:id",
    name: "ObatEdit",
    component: ObatEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/periksa-lab",
    name: "PeriksaLab",
    component: PeriksaLab,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/periksa-lab/form",
    name: "PeriksaLabForm",
    component: PeriksaLabForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/periksa-lab/edit/:id",
    name: "PeriksaLabEdit",
    component: PeriksaLabEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/petugas",
    name: "Petugas",
    component: Petugas,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/petugas/form",
    name: "PetugasForm",
    component: PetugasForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/petugas/edit/:id",
    name: "PetugasEdit",
    component: PetugasEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/provinsi",
    name: "Provinsi",
    component: Provinsi,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/provinsi/form",
    name: "ProvinsiForm",
    component: ProvinsiForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/provinsi/edit/:id",
    name: "ProvinsiEdit",
    component: ProvinsiEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/bank",
    name: "Bank",
    component: Bank,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/bank/form",
    name: "BankForm",
    component: BankForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/bank/edit/:id",
    name: "BankEdit",
    component: BankEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/asuransi-lain",
    name: "AsuransiLain",
    component: AsuransiLain,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/asuransi-lain/form",
    name: "AsuransiLainForm",
    component: AsuransiLainForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/asuransi-lain/edit/:id",
    name: "AsuransiLainEdit",
    component: AsuransiLainEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/wilayah/kota/:id_provinsi",
    name: "WilayahKota",
    component: WilayahKota,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/wilayah/kecamatan/:id_kota",
    name: "WilayahKecamatan",
    component: WilayahKecamatan,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/wilayah/kelurahan/:id_kecamatan",
    name: "WilayahKelurahan",
    component: WilayahKelurahan,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/lokasi",
    name: "Lokasi",
    component: Lokasi,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/lokasi/form",
    name: "LokasiForm",
    component: LokasiForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/lokasi/edit/:id",
    name: "LokasiEdit",
    component: LokasiEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/tindakan",
    name: "Tindakan",
    component: Tindakan,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/tindakan/form",
    name: "TindakanForm",
    component: TindakanForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/tindakan/edit/:id",
    name: "TindakanEdit",
    component: TindakanEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/unit",
    name: "Unit",
    component: Unit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/unit/form",
    name: "UnitForm",
    component: UnitForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/unit/edit/:id",
    name: "UnitEdit",
    component: UnitEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/user",
    name: "User",
    component: User,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/user/form",
    name: "UserForm",
    component: UserForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/user/edit/:id",
    name: "UserEdit",
    component: UserEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/user/change-password/:id",
    name: "UserChangePassword",
    component: UserChangePassword,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/faskes",
    name: "Faskes",
    component: Faskes,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/faskes/form",
    name: "FaskesForm",
    component: FaskesForm,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/master/faskes/edit/:id",
    name: "FaskesEdit",
    component: FaskesEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: { authorize: [] },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/pasien",
    name: "DashboardPasien",
    component: DashboardPasien,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/penyakit",
    name: "DashboardPenyakit",
    component: DashboardPenyakit,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/obat",
    name: "DashboardObat",
    component: DashboardObat,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/optik",
    name: "DashboardOptik",
    component: DashboardOptik,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/tindakan",
    name: "DashboardTindakan",
    component: DashboardTindakan,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/lab",
    name: "DashboardLab",
    component: DashboardLab,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/menular",
    name: "DashboardMenular",
    component: DashboardMenular,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/rujukan",
    name: "DashboardRujukan",
    component: DashboardRujukan,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/bor",
    name: "DashboardBor",
    component: DashboardBor,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/alos",
    name: "DashboardAlos",
    component: DashboardAlos,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/bto",
    name: "DashboardBto",
    component: DashboardBto,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/toi",
    name: "DashboardToi",
    component: DashboardToi,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/ndr",
    name: "DashboardNdr",
    component: DashboardNdr,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/gdr",
    name: "DashboardGdr",
    component: DashboardGdr,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/bj",
    name: "DashboardBj",
    component: DashboardBj,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/rl",
    name: "DashboardRl",
    component: DashboardRl,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/rl2",
    name: "DashboardRl2",
    component: DashboardRl2,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/rl3",
    name: "DashboardRl3",
    component: DashboardRl3,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/rl4",
    name: "DashboardRl4",
    component: DashboardRl4,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/rl5",
    name: "DashboardRl5",
    component: DashboardRl5,
    meta: { authorize: [] },
  },
  {
    path: "/dashboard/ro",
    name: "DashboardRo",
    component: DashboardRo,
    meta: { authorize: [] },
  },
  {
    path: "/antrian",
    name: "Antrian",
    component: Antrian,
    meta: { authorize: ["admin", "admission"] },
  },
  {
    path: "/antrian/pasien",
    name: "AntrianPasien",
    component: AntrianPasien,
    meta: { authorize: ["admin", "pasien", "admission", "antrian"] },
  },
  {
    path: "/antrian/selesai",
    name: "AntrianSelesai",
    component: AntrianSelesai,
    meta: { authorize: ["admin", "pasien", "admission"] },
  },
  {
    path: "/apotik",
    name: "Apotik",
    component: Apotik,
    meta: { authorize: ["admin", "apotik"] },
  },
  {
    path: "/kasir",
    name: "Kasir",
    component: Kasir,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/ralan",
    name: "KasirRalan",
    component: KasirRalan,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/ranap",
    name: "KasirRanap",
    component: KasirRanap,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/ugd",
    name: "KasirUgd",
    component: KasirUgd,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/obat",
    name: "KasirObat",
    component: KasirObat,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/optik",
    name: "KasirOptik",
    component: KasirOptik,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/lab",
    name: "KasirLab",
    component: KasirLab,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/operasi",
    name: "KasirOperasi",
    component: KasirOperasi,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/lab",
    name: "Lab",
    component: Lab,
    meta: { authorize: ["admin", "lab"] },
  },
  {
    path: "/operasi",
    name: "Operasi",
    component: Operasi,
    meta: { authorize: ["admin", "admission", "operasi", "dokter"] },
  },
  {
    path: "/optik",
    name: "Optik",
    component: Optik,
    meta: { authorize: ["admin", "optik"] },
  },
  {
    path: "/pasien",
    name: "Pasien",
    component: Pasien,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "ugd",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
      ],
    },
  },
  {
    path: "/pasien/mutasi",
    name: "PasienMutasi",
    component: PasienMutasi,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "ugd",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
      ],
    },
  },
  {
    path: "/pasien/retensi",
    name: "PasienRetensi",
    component: PasienRetensi,
    meta: {
      authorize: [
        "admin",
        "admission",
        "ralan",
        "ranap",
        "ugd",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
      ],
    },
  },
  {
    path: "/ralan",
    name: "Ralan",
    component: Ralan,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "operasi",
        "lab",
        "apotik",
        "optik",
        "dokter",
      ],
    },
  },
  {
    path: "/ranap",
    name: "Ranap",
    component: Ranap,
    meta: { authorize: ["admin", "admission", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ugd",
    name: "Ugd",
    component: Ugd,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ranap",
        "ugd",
        "operasi",
        "lab",
        "apotik",
        "optik",
        "dokter",
      ],
    },
  },
  {
    path: "/apotik/detail/:id",
    name: "ApotikDetail",
    component: ApotikDetail,
    meta: { authorize: ["admin", "apotik"] },
  },
  {
    path: "/kasir/detail/:id",
    name: "KasirDetail",
    component: KasirDetail,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/lab/detail/:id",
    name: "LabDetail",
    component: LabDetail,
    meta: { authorize: ["admin", "lab"] },
  },
  {
    path: "/operasi/detail/:id_ralan/:id",
    name: "OperasiDetail",
    component: OperasiDetail,
    meta: { authorize: ["admin", "operasi", "dokter"] },
  },
  {
    path: "/operasi/form-biaya/:id_ralan/:id",
    name: "OperasiFormBiaya",
    component: OperasiFormBiaya,
    meta: { authorize: ["admin", "operasi", "dokter"] },
  },
  {
    path: "/operasi/form-ceklis/:id_ralan/:id",
    name: "OperasiFormCeklis",
    component: OperasiFormCeklis,
    meta: { authorize: ["admin", "operasi", "dokter"] },
  },
  {
    path: "/operasi/form-kondisi/:id_ralan/:id",
    name: "OperasiFormKondisi",
    component: OperasiFormKondisi,
    meta: { authorize: ["admin", "operasi", "dokter"] },
  },
  {
    path: "/operasi/form-laporan/:id_ralan/:id",
    name: "OperasiFormLaporan",
    component: OperasiFormLaporan,
    meta: { authorize: ["admin", "operasi", "dokter"] },
  },
  {
    path: "/operasi/form-obat/:id_ralan/:id",
    name: "OperasiFormObat",
    component: OperasiFormObat,
    meta: { authorize: ["admin", "operasi", "dokter"] },
  },
  {
    path: "/operasi/form-surveilans/:id_ralan/:id",
    name: "OperasiFormSurveilans",
    component: OperasiFormSurveilans,
    meta: { authorize: ["admin", "operasi", "dokter"] },
  },
  {
    path: "/operasi/form-tindakan/:id_ralan/:id",
    name: "OperasiFormTindakan",
    component: OperasiFormTindakan,
    meta: { authorize: ["admin", "operasi", "dokter"] },
  },
  {
    path: "/optik/detail/:id",
    name: "OptikDetail",
    component: OptikDetail,
    meta: { authorize: ["admin", "optik"] },
  },
  {
    path: "/pasien/detail/:id",
    name: "PasienDetail",
    component: PasienDetail,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
        "pasien",
      ],
    },
  },
  {
    path: "/pasien/cetak-kartu/:id",
    name: "PasienCetakKartu",
    component: PasienCetakKartu,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
        "pasien",
      ],
    },
  },
  {
    path: "/pasien/cetak-riwayat-kontrol/:id",
    name: "PasienCetakRiwayatKontrol",
    component: PasienCetakRiwayatKontrol,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
        "pasien",
      ],
    },
  },
  {
    path: "/ralan/detail/:id",
    name: "RalanDetail",
    component: RalanDetail,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
      ],
    },
  },
  {
    path: "/ralan/cetak-kajian-medis/:id",
    name: "RalanCetakKajianMedis",
    component: RalanCetakKajianMedis,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
      ],
    },
  },
  {
    path: "/ralan/cetak-resep-obat/:id",
    name: "RalanCetakResepObat",
    component: RalanCetakResepObat,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
      ],
    },
  },
  {
    path: "/ralan/cetak-resep-optik/:id",
    name: "RalanCetakResepOptik",
    component: RalanCetakResepOptik,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
      ],
    },
  },
  {
    path: "/ranap/detail/:id",
    name: "RanapDetail",
    component: RanapDetail,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ugd/detail/:id",
    name: "UgdDetail",
    component: UgdDetail,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ugd",
        "ranap",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
      ],
    },
  },
  {
    path: "/apotik/form/:id",
    name: "ApotikForm",
    component: ApotikForm,
    meta: { authorize: ["admin", "apotik"] },
  },
  {
    path: "/kasir/form/:id/:tab",
    name: "KasirForm",
    component: KasirForm,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/form/ralan/:id/:tab",
    name: "KasirFormRalan",
    component: KasirFormRalan,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/form/ranap/:id/:tab",
    name: "KasirFormRanap",
    component: KasirFormRanap,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/form/ugd/:id/:tab",
    name: "KasirFormUgd",
    component: KasirFormUgd,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/form/obat/:id/:tab",
    name: "KasirFormObat",
    component: KasirFormObat,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/form/optik/:id/:tab",
    name: "KasirFormOptik",
    component: KasirFormOptik,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/form/lab/:id/:tab",
    name: "KasirFormLab",
    component: KasirFormLab,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/form/operasi/:id/:id_operasi_biaya/:tab",
    name: "KasirFormOperasi",
    component: KasirFormOperasi,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/invoice/:id/:tab",
    name: "KasirInvoice",
    component: KasirInvoice,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/invoice/ranap/:id/:tab",
    name: "KasirInvoiceRanap",
    component: KasirInvoiceRanap,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/invoice/ugd/:id/:tab",
    name: "KasirInvoiceUgd",
    component: KasirInvoiceUgd,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/invoice/obat/:id/:tab",
    name: "KasirInvoiceObat",
    component: KasirInvoiceObat,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/invoice/optik/:id/:tab",
    name: "KasirInvoiceOptik",
    component: KasirInvoiceOptik,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/invoice/lab/:id/:tab",
    name: "KasirInvoiceLab",
    component: KasirInvoiceLab,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/kasir/invoice/operasi/:id/:id_operasi_biaya/:tab",
    name: "KasirInvoiceOperasi",
    component: KasirInvoiceOperasi,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/lab/form/:id",
    name: "LabForm",
    component: LabForm,
    meta: { authorize: ["admin", "lab"] },
  },
  {
    path: "/operasi/form/:id/:darurat",
    name: "OperasiForm",
    component: OperasiForm,
    meta: { authorize: ["admin", "operasi", "dokter"] },
  },
  {
    path: "/operasi/form/:id_ralan/edit/:id",
    name: "OperasiFormEdit",
    component: OperasiFormEdit,
    meta: { authorize: ["admin", "operasi", "dokter"] },
  },
  {
    path: "/optik/form/:id",
    name: "OptikForm",
    component: OptikForm,
    meta: { authorize: ["admin", "optik"] },
  },
  {
    path: "/pasien/form",
    name: "PasienForm",
    component: PasienForm,
    meta: { authorize: ["admin", "admission", "dokter", "pasien"] },
  },
  {
    path: "/pasien/form/:id",
    name: "PasienFormEdit",
    component: PasienFormEdit,
    meta: { authorize: ["admin", "admission", "dokter"] },
  },
  {
    path: "/ralan/daftar",
    name: "RalanDaftar",
    component: RalanDaftar,
    meta: { authorize: ["admin", "admission", "ralan", "pasien"] },
  },
  {
    path: "/ralan/cetak-kartu/:id",
    name: "RalanCetakKartu",
    component: RalanCetakKartu,
    meta: {
      authorize: [
        "admin",
        "kasir",
        "admission",
        "ralan",
        "ranap",
        "operasi",
        "kasir",
        "lab",
        "apotik",
        "optik",
        "dokter",
        "pasien",
      ],
    },
  },
  {
    path: "/ralan/form/:no_rm",
    name: "RalanForm",
    component: RalanForm,
    meta: { authorize: ["admin", "admission", "ralan", "pasien"] },
  },
  {
    path: "/ralan/form/edit/:id",
    name: "RalanFormEdit",
    component: RalanFormEdit,
    meta: { authorize: ["admin", "admission", "ralan"] },
  },
  {
    path: "/ralan/form-petugas/:id",
    name: "RalanFormPetugas",
    component: RalanFormPetugas,
    meta: { authorize: ["admin", "ralan", "dokter"] },
  },
  {
    path: "/ralan/form-ophthalmic/:id",
    name: "RalanFormOphthalmic",
    component: RalanFormOphthalmic,
    meta: { authorize: ["admin", "ralan", "ophthalmic"] },
  },
  {
    path: "/ralan/form-dokter/:id",
    name: "RalanFormDokter",
    component: RalanFormDokter,
    meta: { authorize: ["admin", "ralan", "dokter"] },
  },
  {
    path: "/ralan/form-petugas/edit/:id",
    name: "RalanFormPetugasEdit",
    component: RalanFormPetugasEdit,
    meta: { authorize: ["admin", "ralan", "dokter"] },
  },
  {
    path: "/ralan/form-ophthalmic/edit/:id",
    name: "RalanFormOphthalmicEdit",
    component: RalanFormOphthalmicEdit,
    meta: { authorize: ["admin", "ralan", "ophthalmic"] },
  },
  {
    path: "/ralan/form-dokter/edit/:id",
    name: "RalanFormDokterEdit",
    component: RalanFormDokterEdit,
    meta: { authorize: ["admin", "ralan", "dokter"] },
  },
  {
    path: "/ralan/form-tindakan/:id",
    name: "RalanFormTindakan",
    component: RalanFormTindakan,
    meta: { authorize: ["admin", "ralan", "dokter"] },
  },
  {
    path: "/ralan/form-obat/:id",
    name: "RalanFormObat",
    component: RalanFormObat,
    meta: { authorize: ["admin", "ralan", "dokter"] },
  },
  {
    path: "/ralan/form-optik/:id",
    name: "RalanFormOptik",
    component: RalanFormOptik,
    meta: { authorize: ["admin", "ralan", "dokter"] },
  },
  {
    path: "/ranap/form/:id/:darurat",
    name: "RanapForm",
    component: RanapForm,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ranap/form/:id/edit/:id_ranap",
    name: "RanapFormEdit",
    component: RanapFormEdit,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ranap/form-petugas/:id",
    name: "RanapFormPetugas",
    component: RanapFormPetugas,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ranap/form-dokter/:id",
    name: "RanapFormDokter",
    component: RanapFormDokter,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ranap/form-petugas/:id/edit/:id_form",
    name: "RanapFormPetugasEdit",
    component: RanapFormPetugasEdit,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ranap/form-dokter/:id/edit/:id_form",
    name: "RanapFormDokterEdit",
    component: RanapFormDokterEdit,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ranap/form-tagihan/:id",
    name: "RanapFormTagihan",
    component: RanapFormTagihan,
    meta: { authorize: ["admin", "ranap", "tagihan", "kasir"] },
  },
  {
    path: "/ranap/form-tagihan/:id/edit/:id_form",
    name: "RanapFormTagihanEdit",
    component: RanapFormTagihanEdit,
    meta: { authorize: ["admin", "ranap", "tagihan", "kasir"] },
  },
  {
    path: "/ranap/form-tindakan/:id",
    name: "RanapFormTindakan",
    component: RanapFormTindakan,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ranap/form-obat/:id",
    name: "RanapFormObat",
    component: RanapFormObat,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ranap/form-lab/:id",
    name: "RanapFormLab",
    component: RanapFormLab,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ranap/form-tindakan/:id/edit/:tgl_tindakan",
    name: "RanapFormTindakanEdit",
    component: RanapFormTindakanEdit,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  // {
  //   path: "/ranap/form-tagihan/:id",
  //   name: "RanapFormTagihan",
  //   component: RanapFormTagihan,
  //   meta: { authorize: ['admin','ranap','kasir'] }
  // },
  {
    path: "/ugd/daftar",
    name: "UgdDaftar",
    component: UgdDaftar,
    meta: { authorize: ["admin", "admission", "ugd"] },
  },
  {
    path: "/ugd/form/:no_rm",
    name: "UgdForm",
    component: UgdForm,
    meta: { authorize: ["admin", "admission", "ugd"] },
  },
  {
    path: "/ugd/form/edit/:id",
    name: "UgdFormEdit",
    component: UgdFormEdit,
    meta: { authorize: ["admin", "admission", "ugd"] },
  },
  {
    path: "/ugd/form-petugas/:id",
    name: "UgdFormPetugas",
    component: UgdFormPetugas,
    meta: { authorize: ["admin", "ugd", "dokter"] },
  },
  {
    path: "/ugd/form-triase/:id",
    name: "UgdFormTriase",
    component: UgdFormTriase,
    meta: { authorize: ["admin", "ugd", "dokter"] },
  },
  {
    path: "/ugd/form-triase/edit/:id",
    name: "UgdFormTriaseEdit",
    component: UgdFormTriaseEdit,
    meta: { authorize: ["admin", "ugd", "dokter"] },
  },
  {
    path: "/ugd/form-ophthalmic/:id",
    name: "UgdFormOphthalmic",
    component: UgdFormOphthalmic,
    meta: { authorize: ["admin", "ugd", "ophthalmic"] },
  },
  {
    path: "/ugd/form-dokter/:id",
    name: "UgdFormDokter",
    component: UgdFormDokter,
    meta: { authorize: ["admin", "ugd", "dokter"] },
  },
  {
    path: "/ugd/form-petugas/edit/:id",
    name: "UgdFormPetugasEdit",
    component: UgdFormPetugasEdit,
    meta: { authorize: ["admin", "ugd", "dokter"] },
  },
  {
    path: "/ugd/form-ophthalmic/edit/:id",
    name: "UgdFormOphthalmicEdit",
    component: UgdFormOphthalmicEdit,
    meta: { authorize: ["admin", "ugd", "ophthalmic"] },
  },
  {
    path: "/ugd/form-dokter/edit/:id",
    name: "UgdFormDokterEdit",
    component: UgdFormDokterEdit,
    meta: { authorize: ["admin"] },
  },
  {
    path: "/ugd/form-tindakan/:id",
    name: "UgdFormTindakan",
    component: UgdFormTindakan,
    meta: { authorize: ["admin", "ugd", "dokter"] },
  },
  {
    path: "/ugd/form-obat/:id",
    name: "UgdFormObat",
    component: UgdFormObat,
    meta: { authorize: ["admin", "ugd", "dokter"] },
  },
  {
    path: "/ugd/form-optik/:id",
    name: "UgdFormOptik",
    component: UgdFormOptik,
    meta: { authorize: ["admin", "ugd", "dokter"] },
  },
  {
    path: "/ranap/kamar",
    name: "RanapKamar",
    component: RanapKamar,
    meta: { authorize: ["admin", "ranap", "dokter", "kasir"] },
  },
  {
    path: "/ranap/daftar",
    name: "RanapDaftar",
    component: RanapDaftar,
    meta: { authorize: ["admin", "admission", "ranap", "kasir"] },
  },
  {
    path: "/apotik/tebus",
    name: "ApotikTebus",
    component: ApotikTebus,
    meta: { authorize: ["admin", "apotik"] },
  },
  {
    path: "/optik/tebus",
    name: "OptikTebus",
    component: OptikTebus,
    meta: { authorize: ["admin", "optik"] },
  },
  {
    path: "/lab/periksa",
    name: "LabPeriksa",
    component: LabPeriksa,
    meta: { authorize: ["admin", "lab"] },
  },
  {
    path: "/operasi/daftar",
    name: "OperasiDaftar",
    component: OperasiDaftar,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/example",
    name: "DocumentExample",
    component: DocumentExample,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/kajian-medis",
    name: "DocKajianMedis",
    component: DocKajianMedis,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/kartu-pasien",
    name: "DocKartuPasien",
    component: DocKartuPasien,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/ophthalmic",
    name: "DocOphthalmic",
    component: DocOphthalmic,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/penandaan-lokasi-operasi",
    name: "DocPenandaanLokasiOperasi",
    component: DocPenandaanLokasiOperasi,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/penolakan",
    name: "DocPenolakan",
    component: DocPenolakan,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/periksa-pasien",
    name: "DocPeriksaPasien",
    component: DocPeriksaPasien,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/persetujuan",
    name: "DocPersetujuan",
    component: DocPersetujuan,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/laporan-operasi",
    name: "DoclaporanOperasi",
    component: DocLaporanOperasi,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/resep-obat",
    name: "DocResepObat",
    component: DocResepObat,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/resep-optik",
    name: "DocResepOptik",
    component: DocResepOptik,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/riwayat-kontrol",
    name: "DocRiwayatKontrol",
    component: DocRiwayatKontrol,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/stiker-obat",
    name: "DocStikerObat",
    component: DocStikerObat,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/surat-ket-medis",
    name: "DocSuratKetMedis",
    component: DocSuratKetMedis,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/surat-ket-sakit",
    name: "DocSuratKetSakit",
    component: DocSuratKetSakit,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/surat-kontrol",
    name: "DocSuratKontrol",
    component: DocSuratKontrol,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/surat-periksa-mata",
    name: "DocSuratPeriksaMata",
    component: DocSuratPeriksaMata,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/surat-permintaan-konsultasi",
    name: "DocSuratPermintaanKonsultasi",
    component: DocSuratPermintaanKonsultasi,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/surat-rujukan",
    name: "DocSuratRujukan",
    component: DocSuratRujukan,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/document/:slug/surat-rujuk-balik",
    name: "DocSuratRujukBalik",
    component: DocSuratRujukBalik,
    meta: { authorize: ["admin", "admission", "operasi"] },
  },
  {
    path: "/komisi",
    name: "Komisi",
    component: Komisi,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/komisi/form/:id",
    name: "KomisiForm",
    component: KomisiForm,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/komisi/detail/:id",
    name: "KomisiDetail",
    component: KomisiDetail,
    meta: { authorize: ["admin", "kasir"] },
  },
  {
    path: "/komisi/daftar",
    name: "KomisiDaftar",
    component: KomisiDaftar,
    meta: { authorize: ["admin", "kasir"] },
  },

  {
    path: "*",
    redirect: "/login",
  },
];

// let router = new VueRouter({
//   routes,mode:'history'
// });

let router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // let token = store.state.token;
  // let role = store.state.role;
  // try {

  // } catch (error) {
  //   console.log(error);
  // }

  const { authorize } = to.meta;
  if (store.state.token) {
    if (to.fullPath === "/login") {
      next("/");
    } else {
      if (
        authorize &&
        authorize.length &&
        !authorize.includes(store.state.role)
      ) {
        alert("Anda tidak memiliki izin mengakses halaman / fitur ini!");
        if (from) {
          next(from.fullPath);
        } else {
          next("/");
        }
      } else {
        next();
      }
    }
  } else {
    if (to.fullPath == "/login" || to.fullPath == "/antrian/pasien") {
      next();
    } else {
      next("/login");
    }
  }
});

// router.onError((error) => {
//   try {
//     // Handle specific errors
//     if (error.name === "NavigationDuplicated") {
//       // Handle NavigationDuplicated error
//       console.log("Navigating to the same route");
//     } else if (error.name === "MyCustomError") {
//       // Handle custom error
//     } else {
//       // Handle other errors
//       console.error(error);
//     }
//   } catch (error) {
//     console.error(error);
//   }
// });
// router.beforeRouteUpdate((to,from,next)=>{
//   const id=to.params.id;
//   next();
// })

export default router;
